export const SHOP_NAME = "{dukon_nomi}";
export const SHOP_BALANS = "{dukon_balans}";
